import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'

import {
  getTableRowQaProps,
  TableCellFreeSpaceFiller,
  TableRowActions,
  TableRowContextActions,
  useTableRowActions,
  useTableRowModClassName,
} from '../Table'

import { DOC_FLOW_TABLE_ROW_ACTIONS_CONFIG } from './DocFlowTableRow.constants'
import { renderCell } from './DocFlowTableRow.utils'

import * as styles from './DocFlowTableRow.module.css'

function DocFlowTableRow({
  Actions = TableRowActions,
  actionLeft,
  actionsColumnWidth,
  columns,
  emptyColumnSize,
  focusedRow,
  getActions,
  hideCheckbox,
  isResizing,
  isSelected,
  isShort,
  item,
  resizingColumn,
  scrollRef,
  showCellBorder,
  ...restProps
}) {
  const { t } = useTranslation()

  const { id } = item

  const {
    handleCallAction,
    handleClick,
    handleMouseDown,
    handleMouseEnter,
    handleMouseLeave,
    handleSelect,
  } = useTableRowActions(
    { item, ...restProps },
    DOC_FLOW_TABLE_ROW_ACTIONS_CONFIG
  )

  const className = useTableRowModClassName({
    className: styles.DocFlowTableRow,
    isSelected,
  })

  const qaProps = getTableRowQaProps()

  return (
    <div
      {...qaProps}
      className={className}
      key={id}
      onClick={handleClick}
      onMouseDown={handleMouseDown}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {Actions ? (
        <Actions
          disabled={hideCheckbox}
          selected={isSelected}
          width={actionsColumnWidth}
          onChange={handleSelect}
        />
      ) : null}
      {columns.map(column => (
        <Fragment key={column.name}>
          {renderCell({
            isActive: column.name === resizingColumn,
            isResizing,
            isShort,
            item,
            name: column.name,
            scrollRef,
            showCellBorder,
            t,
            width: column.width,
          })}
        </Fragment>
      ))}
      <TableCellFreeSpaceFiller width={emptyColumnSize} />
      {getActions?.(item).length > 0 ? (
        <TableRowContextActions
          actionLeft={actionLeft}
          focusedRow={focusedRow}
          getActions={getActions}
          item={item}
          onCallAction={handleCallAction}
        />
      ) : null}
    </div>
  )
}

export default DocFlowTableRow
